import React, { useState, useCallback } from "react";
import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/VisualForm.css";
import ButtonX from "../Images/ButtonX.svg";
import useClipboard from "react-use-clipboard";
import checkIcon from "../Toast/Image/check.svg";
import Toast from "../Toast/Toast";
import api from "../../services/api/index";
import { readDataStorage } from "../../utils/storage/storage";
import { useProgress } from "../../hooks/progress";
import error from "../Toast/Image/error.svg";
import success from "../Toast/Image/check.svg";
import info from "./images/Info.svg";
import { useAPI } from "../../hooks/contextApis";
import InputDragDrop from "../Inputs/InputDragDropFatura";

export default function ModalA({
  isOpen,
  onRequestClose,
  onUpdate,
  id,
  mensalidade,
  cidade,
  concessionaria,
  endereco,
  status,
  linkArp,
  telefoneCliente,
  emailCliente,
  unidade,
  dtCriacao,
  dtAtualizacao,
  nome,
  descri_o,
  fatura,
  chaveWhats,
  totalReenvio,
}) {
  const emailLink = "mailto:" + emailCliente;
  const limparNumero = (numero) => {
    return numero?.replace(/\D/g, "");
  };

  const telefone = `https://wa.me/${limparNumero(telefoneCliente)}`;

  const link = linkArp;
  const [, /*copy*/ setCopy] = useClipboard(link);
  const [openText, setOpenText] = useState(false);
  const { isLoad, setLoad } = useProgress();
  const [isClose] = useState(false);
  const { setDados } = useAPI();
  const {
    IdCard
  } = readDataStorage("login");
  const [uploadedImage, setUploadedImage] = useState(null);

  const [list, setList] = useState([]);

  let toastProperties = null;
  // eslint-disable-next-line
  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);

    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "",
          description: "Link copiado para área de transferência",
          backgroundColor: "#5cb85c",
          icon: checkIcon,
        };
        break;
      case "erroSendFatura":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao enviar fatura",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "warning":
        toastProperties = {
          id,
          title: "",
          description: "Erro ao exluir",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "successSend":
        toastProperties = {
          id,
          title: "",
          description: "Fatura enviada com sucesso",
          backgroundColor: "#f0ad4e",
          icon: success,
        };
        break;

      case "limitSend":
        toastProperties = {
          id,
          title: "",
          description: "Limite de reenvio atingido",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "warningContact":
        toastProperties = {
          id,
          title: "",
          description: "Contrato não encontrado",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      case "successContact":
        toastProperties = {
          id,
          title: "",
          description: "Contrato enviado",
          backgroundColor: "#f0ad4e",
          icon: success,
        };
        break;

      case "semAnexo":
        toastProperties = {
          id,
          title: "",
          description: "Anexo vazio",
          backgroundColor: "#f0ad4e",
          icon: error,
        };
        break;
      default:
        setList([]);
    }

    setList([...list, toastProperties]);
  };

  const handleClick = () => {
    setCopy();
    showToast("success");
  };

  const handleClickText = () => {
    setOpenText(!openText);
  };

  const handleSendFatura = useCallback(async () => {
    setLoad(true);
    await api
      .post("/csp/usuario/fatura/enviar/", {
        idCard: id,
        numeroInstalacao: unidade,
        tipoArquivo: uploadedImage?.tipoArquivo,
        fatura: uploadedImage?.fatura,
      })
      .then((res) => {
        if (res.status === 200) {
          setLoad(false);
          showToast("successSend");
        }
      })
      .catch((error) => {
        setLoad(false);
        if (error.response.status === 404) {
          showToast("erroSendFatura");
          setLoad(false);
        }
        if (error.response.status === 500) {
          showToast("erroSendFatura");
          setLoad(false);
        }
      });
  }, [setLoad, showToast, id, unidade, uploadedImage]);

  const TypesDocuments = ["PDF", "PNG", "JPG", "JPEG"];

  function setBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        const dataURL = reader.result;
        const base64Data = dataURL.split(",")[1];
        const tipoArquivo = dataURL.split(",")[0];

        const data = {
          fatura: base64Data,
          tipoArquivo: tipoArquivo,
        };
        resolve(data);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  const max_file_size = 5 * 1024 * 1024;

  const isValidFileType = (file) => {
    const fileExtension = file.name.split(".").pop()?.toUpperCase();
    return TypesDocuments.includes(fileExtension);
  };

  const handleImageChange = async (image) => {
    if (image?.size <= max_file_size) {
      if (isValidFileType(image)) {
        const imageData = await setBase64(image);
        setUploadedImage(imageData);
      }
    } else if (image !== null) {
      showToast("LimiteTamanhoArquivo");
    }
  };

  const handleReSendContact = () => {
    setLoad(true);
    api
      .post(`/csp/representante/contrato/reenvio/`, {
        idCard: id,
      })
      .then((res) => {
        if (res.status === 200) {
          setLoad(false);
          showToast("successContact");
          onUpdate(id);
        }
        if (res.status === 202) {
          setLoad(false);
          showToast("limitSend");
          onUpdate(id);
        }
      })
      .catch((error) => {
        if (error.response.status >= 400) {
          showToast("warningContact");
          setLoad(false);
        }
        setLoad(false);
      });
  };

  const dataSend = useCallback((id, tipo, formato) => {
    let object = {
      id: id,
      tipo: tipo,
      formato: formato,
    };
    return object;
  }, []);

  const handleExit = useCallback(() => {
    setOpenText(false);
    onRequestClose();
  }, [setOpenText, onRequestClose]);

  const handleBack = useCallback(async () => {
      setDados({ id: IdCard }); 
      handleExit();
  }, [
    setDados,
    IdCard
  ]);

  const handleExclude = () => {
    setLoad(true);
    api.defaults.headers.common = {
      Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
    };
    api
      .post(`/csp/representante/excluir/card/`, {
        idCard: id,
      })
      .then((res) => {
        setLoad(false);
        handleBack();
      })
      .catch((error) => {
        if (error.response.status >= 400) {
          showToast("warning");
          setLoad(false);
        }
        setLoad(false);
      });
  };

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          if (isClose === true) {
            onRequestClose();
          }
        }}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close",
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <div className="imgX" onClick={handleExit}>
          <img alt={""} src={ButtonX}></img>
        </div>
        <div className="grid-floatVisual" onClick={handleClickText}>
          <div className="label-floatVisual">
            <label className="modalTitlePuple">
              Dados da proposta - ID card: {id}
            </label>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Cliente:</label>
            <span className="ulText">{nome}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Valor AXS:</label>
            <span className="ulText">{mensalidade}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Telefone:</label>
            <span className="ulText">
              <a
                style={{ color: "black" }}
                target="_blank"
                rel="noreferrer"
                href={telefone}
              >
                {telefoneCliente}
              </a>
            </span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Email:</label>
            <span className="ulText">
              <a style={{ color: "black" }} href={emailLink}>
                {emailCliente}
              </a>
            </span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Endereço:</label>
            <span className="ulText">{endereco}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Cidade:</label>
            <span className="ulText">{cidade}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Concessionária:</label>
            <span className="ulText">{concessionaria}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Unidade Consumidora:</label>
            <span className="ulText">{unidade}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Data de criação:</label>
            <span className="ulText">{dtCriacao}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Data de Atualização:</label>
            <span className="ulText">{dtAtualizacao}</span>
          </div>
          <div className="label-floatVisual">
            <label className="labelVisual">Status atual:</label>
            <span className="ulText">{status}</span>
          </div>
          <div className="label-floatVisual" style={{ display: "flex" }}>
            <label className="labelVisual">Descrição:</label>
            <span className="longTextModal">
              <span className="ulText">{descri_o}</span>
            </span>
            <img
              style={{ cursor: "pointer" }}
              src={info}
              alt=""
              onClick={handleClickText}
              width={20}
            />
            <div className={`${openText ? "show" : "hide"}`}>{descri_o}</div>
          </div>
        </div>
        <div
          style={fatura === undefined ? {} : { display: "none" }}
          className="alignLink label-floatVisual"
        >
          <label className="labelVisual ">Anexar fatura</label>
        </div>
        <div
          style={fatura === undefined ? {} : { display: "none" }}
          className="form-group disablemobile"
        >
          <InputDragDrop
            onImageChange={handleImageChange}
            maxFileSize={max_file_size}
            onHandleSend={() =>
              uploadedImage === null
                ? showToast("semAnexo")
                : handleSendFatura()
            }
            onExcludeImage={(image) => setUploadedImage(image)}
          ></InputDragDrop>
        </div>
        <div className="alignLink label-floatVisual">
          <label className="labelVisual ">Link da proposta</label>
        </div>
        <div className="form-group disablemobile" onClick={handleClick}>
          <input
            className="form-field"
            type="email"
            placeholder="Link"
            defaultValue={link}
            disabled
          ></input>
          <span>Copiar link da proposta</span>
        </div>
        <button
          className="btnContact"
          onClick={handleReSendContact}
          disabled={
            !(
              status === "Aguardando Assinatura" &&
              chaveWhats !== null &&
              totalReenvio !== "1"
            ) || isLoad
          }
        >
          Reenviar contrato
        </button>

        <button className="btnExclude" onClick={handleExclude}>
          Excluir
        </button>
      </Modal>
    </>
  );
}
